import {SelectOption} from 'components/ui-kit/Select';
import {ProductGroup} from 'core/constants/productGroups';
import {AllowancesByProductGroup, ALLOWED_REASONS, PRODUCT_CONDITIONS} from 'types';

export const ALLOWANCES_BY_PRODUCT_GROUP: Record<ProductGroup, AllowancesByProductGroup> = {
    ALCOHOL: {
        consumerReturnAllowed: true,
        reintroductionAllowed: true,
        remarkingAllowed: true,
        documentsRequared: false,
        allowedReasons: [
            ALLOWED_REASONS.RETURN_FROM_CONSUMER,
            ALLOWED_REASONS.PACKAGING_DAMAGE,
            ALLOWED_REASONS.DESTRUCTION,
            ALLOWED_REASONS.SPOILAGE,
        ],
    },
    TOBACCO: {
        consumerReturnAllowed: true,
        reintroductionAllowed: true,
        remarkingAllowed: false,
        documentsRequared: false,
        allowedReasons: [
            ALLOWED_REASONS.RETURN_FROM_CONSUMER,
            ALLOWED_REASONS.PACKAGING_DAMAGE,
            ALLOWED_REASONS.DESTRUCTION,
        ],
    },
    MEDICATIONS: {
        consumerReturnAllowed: true,
        reintroductionAllowed: false,
        remarkingAllowed: false,
        documentsRequared: true,
        allowedReasons: [
            ALLOWED_REASONS.RETURN_FROM_CONSUMER,
            ALLOWED_REASONS.EXPIRATION,
            ALLOWED_REASONS.DESTRUCTION,
        ],
    },
    VETERINARY: {
        consumerReturnAllowed: true,
        reintroductionAllowed: false,
        remarkingAllowed: false,
        documentsRequared: true,
        allowedReasons: [
            ALLOWED_REASONS.RETURN_FROM_CONSUMER,
            ALLOWED_REASONS.EXPIRATION,
            ALLOWED_REASONS.DESTRUCTION,
        ],
    },
    COFFEE: {
        consumerReturnAllowed: true,
        reintroductionAllowed: true,
        remarkingAllowed: true,
        documentsRequared: false,
        allowedReasons: [
            ALLOWED_REASONS.RETURN_FROM_CONSUMER,
            ALLOWED_REASONS.PACKAGING_DAMAGE,
            ALLOWED_REASONS.DESTRUCTION,
            ALLOWED_REASONS.SPOILAGE,
        ],
    },
    DRINKS: {
        consumerReturnAllowed: true,
        reintroductionAllowed: true,
        remarkingAllowed: true,
        documentsRequared: false,
        allowedReasons: [
            ALLOWED_REASONS.RETURN_FROM_CONSUMER,
            ALLOWED_REASONS.PACKAGING_DAMAGE,
            ALLOWED_REASONS.DESTRUCTION,
            ALLOWED_REASONS.SPOILAGE,
        ],
    },
    FUEL: {
        consumerReturnAllowed: false,
        reintroductionAllowed: false,
        remarkingAllowed: false,
        documentsRequared: true,
        allowedReasons: [ALLOWED_REASONS.DESTRUCTION],
    },
    BIOFUELS: {
        consumerReturnAllowed: false,
        reintroductionAllowed: false,
        remarkingAllowed: false,
        documentsRequared: true,
        allowedReasons: [ALLOWED_REASONS.DESTRUCTION],
    },
};

export enum PRODUCT_CONDITION_OPTIONS {
    FIT_FOR_SALE = 'FIT_FOR_SALE',
    NOT_FIT_FOR_SALE = 'NOT_FIT_FOR_SALE',
}
